/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Team_ApproveInputs */

const en_inbox_na_team_approve = /** @type {(inputs: Inbox_Na_Team_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve the team stage`)
};

const id_inbox_na_team_approve = /** @type {(inputs: Inbox_Na_Team_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui tahap tim`)
};

/**
* | output |
* | --- |
* | "Approve the team stage" |
*
* @param {Inbox_Na_Team_ApproveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_team_approve = /** @type {((inputs?: Inbox_Na_Team_ApproveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Team_ApproveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_team_approve(inputs)
	return en_inbox_na_team_approve(inputs)
});